import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top on every route change so each page lands at its hero,
 * except when the URL has a hash target (#section) — in that case we honor it.
 */
export const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            // let the browser handle the anchor
            const el = document.getElementById(hash.replace("#", ""));
            if (el) {
                el.scrollIntoView({ behavior: "instant", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);

    return null;
};
